/**
 * Filters form fields to only include editable (non-readonly and visible) fields
 *
 * @template T - Type of the form field object
 * @param fields - The form fields to filter
 * @returns Filtered array of editable fields
 * @example
 * interface FormField {
 *   field: {
 *     show: boolean;
 *     readonly: boolean;
 *   }
 * }
 * const formFields: FormField[] = [...];
 * const editableFields = filterEditableFields<FormField>(formFields);
 */
export const filterEditableFields = <T extends { field: { show?: boolean; readonly?: boolean } }>(
    fields: T[]
): T[] => fields.filter(f => f.field.show && !f.field.readonly);
